<template>
  <svg :viewBox="svg.viewBox" v-bind="attr" role="img" :aria-label="ariaLabel">
    <use :href="`#${svg.id}`" />
  </svg>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue';

defineProps<{
  svg: {
    viewBox: string;
    id: string;
  };
  ariaLabel?: string;
}>();
const attr = useAttrs();
</script>
